module.exports = __webpack_public_path__ + "img/categories-bedding.01a661d.png";